import script from "./PCLectorArticuloElaborado.vue?vue&type=script&setup=true&lang=js"
export * from "./PCLectorArticuloElaborado.vue?vue&type=script&setup=true&lang=js"

import "./PCLectorArticuloElaborado.vue?vue&type=style&index=0&id=0cb0520e&lang=scss"

const __exports__ = script;

export default __exports__